import { ProductType } from './../../../client';
import { PaymentMethodsValue, ProductDetailValue, ProductDetailVariantValue } from './../../../server';

// TODO : locally created but this type will be created with Quick View use case
type LoyaltyBenefitsValue = {
    earnedPoints: number;
};

export type ProductDetailInformationValue = Pick<
    ProductDetailValue,
    | 'sku'
    | 'name'
    | 'description'
    | 'rating'
    | 'reviewCount'
    | 'price'
    | 'priorPrice'
    | 'originalPrice'
    | 'pricePerUnit'
    | 'priceBeforeDiscount'
    | 'totalIndividualPrice'
    | 'priceAlwaysBlack'
    | 'currency'
    | 'discountPercentage'
    | 'promotion'
    | 'enableDiscountInfo'
    | 'stockLevel'
    | 'medias'
    | 'isRedDot'
    | 'type'
> & {
    defaultVariantId?: string;
    variants?: ProductDetailVariantValue[];
    loyaltyBenefits?: LoyaltyBenefitsValue;
    buyNowPayLaterContent: PaymentMethodsValue;
};

export const mapProductDetailInformationValue = (productDetail: ProductDetailValue): ProductDetailInformationValue => {
    const productDetailInformationValue = {
        sku: productDetail.sku,
        name: productDetail.name,
        rating: productDetail.rating,
        reviewCount: productDetail.reviewCount,
        description: productDetail.description,
        price: productDetail.price,
        priorPrice: productDetail.priorPrice,
        originalPrice: productDetail.originalPrice,
        pricePerUnit: productDetail.pricePerUnit,
        priceBeforeDiscount: productDetail.priceBeforeDiscount,
        totalIndividualPrice: productDetail.totalIndividualPrice,
        priceAlwaysBlack: productDetail.priceAlwaysBlack,
        currency: productDetail.currency,
        discountPercentage: productDetail.discountPercentage,
        promotion: productDetail.promotion,
        enableDiscountInfo: productDetail.enableDiscountInfo,
        stockLevel: productDetail.stockLevel,
        isRedDot: productDetail.isRedDot,
        medias: productDetail.medias,
        loyaltyBenefits: undefined,
        buyNowPayLaterContent: productDetail.buyNowPayLaterContent,
        type: productDetail.type,
    };

    if (productDetail.type === ProductType.PRODUCT_SET) {
        return productDetailInformationValue;
    }

    return {
        ...productDetailInformationValue,
        variants: productDetail.variants,
        defaultVariantId: productDetail.defaultVariantId,
    };
};
